module.exports = __webpack_public_path__ + "img/0070.b68e39aa.png";